<template>
  <!-- 公司项目 -->
  <div id="enterprise-card6">
    <div class="enterprise-card6-list">
      <div
        class="box-card"
        v-for="(item, index) in table.tableData"
        :key="index"
      >
        <div class="box-card-avatar">{{ item.name[0] }}</div>
        <div class="box-card-content">
          {{ item.name }} <span>{{ item.type }}</span>
        </div>
      </div>
    </div>
    <div class="enterprise-card6-pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="table.pageData.pageIndex"
        :page-size="table.pageData.pageSize"
        layout="prev, pager, next"
        :total="table.pageData.totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", this.table);
    },
  },
};
</script>

<style lang="less" scoped>
#enterprise-card6 {
  .enterprise-card6-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .box-card {
      display: flex;
      align-items: center;
      width: 49%;
      margin-bottom: 10px;
      box-shadow: 0 0 8px #0000001a;
      border-radius: 4px;
      padding: 20px;
      box-sizing: border-box;
      .box-card-avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        border-radius: 4px;
        background-color: rgba(36, 190, 61, 0.1);
        color: rgb(36, 190, 61);
        font-size: 14px;
        text-align: center;
        padding: 0px;
      }
      .box-card-content {
        text-align: left;
        margin-left: 12px;
        font-size: 18px;
        color: #111a34;
        span {
          font-size: 12px;
          color: #111a34;
          height: 18px;
          margin-left: 6px;
          padding: 2px;
          line-height: 18px;
          background: #eceef3;
          border-radius: 2px;
        }
      }
    }
  }
  .enterprise-card6-pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
